module.exports = __webpack_public_path__ + "static/universal-app-icon-P3-556be11b2caa56089cec9d319a96aeff.png";